'use strict';

let angular = require('angular');

let Calendar = require('./controllers/Calendar');
let EventList = require('./controllers/EventList');
let TicketFinder = require('./controllers/TicketFinder');
let TicketFinderNew = require('./controllers/TicketFinderNew');
let TicketFinderList = require('./controllers/TicketFinderList');
let ProductionListCtrl = require('./controllers/ProductionListCtrl');
let NewsSignup = require('./controllers/NewsSignup');
let NewsSearch = require('./controllers/NewsSearch');
let Donation = require('./controllers/Donation');
let PerformanceList = require('./controllers/PerformanceList');
let PromoNotice = require('./controllers/PromoNotice');
let QuickGive = require('./controllers/QuickGive');
let SubNotice = require('./controllers/SubNotice');
let Cart = require('./controllers/Cart');
let BookButton = require('./controllers/BookButton');

angular
    .module('app.controllers', [])
    .controller('Calendar', Calendar)
    .controller('EventList', EventList)
    .controller('TicketFinder', TicketFinder)
    .controller('TicketFinderNew', TicketFinderNew)
    .controller('TicketFinderList', TicketFinderList)
    .controller('ProductionListCtrl', ProductionListCtrl)
    .controller('NewsSignup', NewsSignup)
    .controller('NewsSearch', NewsSearch)
    .controller('Donation', Donation)
    .controller('PerformanceList', PerformanceList)
    .controller('PromoNotice', PromoNotice)
    .controller('QuickGive', QuickGive)
    .controller('SubNotice', SubNotice)
    .controller('Cart', Cart)
    .controller('BookButton', BookButton);



// WEBPACK FOOTER //
// ./widgets/controllers.js